export default "__VITE_ASSET__BfuLEH6Q__"